// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__JfuyV","left":"InfoRow_left__3dxVf"};